module.exports = __webpack_public_path__ + "static/media/promo.b477fb7d.jpg";